import { withInstall } from '@antdv/utils';
import ATransfer from './src/Transfer';

export const Transfer = withInstall(ATransfer);

export default Transfer;

export * from './src/interface';
export * from './src/props';
